module.exports = __webpack_public_path__ + "media/images/card_deck_edit_EN-f98e3201.jpg";